<header class="app-header">
  <div class="header-left">
    <button class="hamburger-menu-btn" (click)="toggleSidebar.emit()">
      <i class="fa-solid fa-bars"></i>
    </button>
    <h1 class="page-title">{{ pageTitle }}</h1>
  </div>

  <div class="header-actions">
    <div class="product-actions" *ngIf="pageTitle === 'Bank Detail'">
      <button class="btn-dark" (click)="triggerBankModal()">Add Bank</button>
    </div>

    <div class="search-bar">
      <i class="fa-solid fa-magnifying-glass search-icon"></i>
      <input
        type="text"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange($event)"
        placeholder="Search Here..."
        class="search-input"
      />
    </div>

    <button class="profile-btn" (click)="logout()">
      <i class="fa-solid fa-right-from-bracket"></i>
    </button>
  </div>
</header>
